import styled from 'styled-components';
import ProductPrivacyStatement from '../ProductPrivacyStatement';

interface Props {
  id?: string;
  showVaultLogo?: boolean;
}

export const Footer = ({ id, showVaultLogo = true }: Props) => {
  return (
    <Container id={id}>
      <ProductPrivacyStatement showVaultLogo={showVaultLogo} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;
